export default function Roles() {
  return (
    <div style={{ padding: 24 }}>
      <h2>Gestión de Roles</h2>
      <p>Desde aquí puedes crear, editar o eliminar roles del sistema.</p>
      {/* Aquí irán formularios o tablas */}
    </div>
  );
}
